module.exports = __webpack_public_path__ + "img/grass-tile-0001.de2afd91.jpg";